/**
 * Host Scripts Page
 *
 * This is a React component that fetches data from the API endpoint and renders a list
 * of scripts associated with a hunt. The component uses the useState and useEffect hooks
 * to manage state and perform the API call. The fetched data is stored in the hunt state
 * variable and also passed to the setActiveHunt method of the HostContext.
 * The component conditionally renders the page header and the list of scripts based on whether the
 * hunt_scripts and shared_scripts arrays exist in the hunt object.
 * The list of scripts displays the titles of the scripts associated with the hunt and the shared scripts.
 * The component also uses the GetScript component to display the titles of the shared scripts.
 */

import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import HostLoginWrapper from '../../components/host/login-wrapper'
import HostContext from '../../utils/host-context'
import API from '../../utils/api'
import SvgArrow from '../../components/svg/arrow'
import { Link } from 'react-router-dom'
import GetScript from '../../components/host/GetScript'

const HostScriptsPage = ({ location }) => {
  const context = useContext(HostContext)
  const [hunt, setHunt] = useState()
  const [updating, setUpdating] = useState(false)

  useEffect(() => {
    const hunt_id = location.hash.substring(1)
    if (!updating) {
      setUpdating(true)
      API.get(`/host/hunt/${hunt_id}/`, {
        headers: {
          Authorization: `JWT ${localStorage.getItem(`token`)}`,
        },
      }).then(res => {
        console.log(res)
        setUpdating(false)
        setHunt(res.data)
        context.setActiveHunt(res.data)
      })
    }
  }, [])

  return (
    <HostLoginWrapper>
      <div className="site-sub-header px-4 py-4 mb-4">
        <div className="row">
          <div className="col-2 d-flex align-items-center">
            <Link to={hunt ? `/host/hunt/#${hunt.id}` : `/host/`} className={`back-arrow`}>
              <SvgArrow />
            </Link>
          </div>
          <div className="col-10 text-right">
            {hunt && (
              <h1 className={`title h5 text-uppercase mb-0`}>
                {hunt.display_title ? hunt.display_title : hunt.title} Scripts
              </h1>
            )}
          </div>
        </div>
      </div>
      <div className="content px-4 pb-5">
        {hunt && (
          <div className="card">
            <div className="card-header">
              <h3>Scripts</h3>
            </div>
            <div className="card-body">
              {hunt.hunt_scripts && (
                <ul className="scripts-wrapper list-unstyled text-larger">
                  {hunt.hunt_scripts.map((item, idx) => {
                    var url = item.url
                    if (item.file_url) {
                      url = item.file_url
                    }
                    return (
                      <li key={`script-${idx}`} className="mb-3">
                        <a href={url} target="_blank" rel="noreferrer" className="h4">
                          {item.title}
                        </a>
                      </li>
                    )
                  })}
                </ul>
              )}

              {hunt.shared_scripts && hunt.shared_scripts.length > 0 && (
                <ul className="scripts-wrapper list-unstyled text-larger">
                  {hunt.shared_scripts.map((item, idx) => {
                    var url = item.url

                    // check if item.host_title exists, if so, use that instead of item.title
                    if (item.host_title) {
                      item.title = item.host_title
                    }

                    if (item.file_url) {
                      url = item.file_url
                    }
                    return (
                      <li key={`script-${idx}`} className="mb-3">
                        <GetScript title={item.title} ID={item.id} />
                      </li>
                    )
                  })}
                </ul>
              )}
            </div>
          </div>
        )}
      </div>
    </HostLoginWrapper>
  )
}

export default HostScriptsPage

HostScriptsPage.propTypes = {
  location: PropTypes.object,
}
